<template>
    <Teleport to="body">
        <div class="modal fade" :class="additionalClass" :id="id" ref="root" tabindex="-1">
            <div class="
                modal-dialog modal-dialog-centered min-h:unset! r:20 box-shadow:0px|4px|20px|0px|#99B1D240 bg:#FFFFFF
                {max-w:1440!;max-h:calc(100dvh-130px);my:65!}@xl
                {max-w:1232!;max-h:calc(100dvh-106px);my:53!}@<xl&>=lg
                {max-w:690!;max-h:calc(100dvh-80px);my:40!}@<lg&>=sm
                {max-h:calc(100dvh-40px);max-w:unset!;my:20!}@<sm
            ">
                <div class="modal-content w:full h:full max-h:inherit">
                    <div class="modal-header">
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body p:0|48|36|48! {p:12|12|24|12!}@<sm overflow-y:auto" :class="bodyClass">
                        <div>
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const root = ref();

    const emit = defineEmits(['shown', 'hidden']);

    let modal;

    const shownHandler = () => {
        emit('shown');
    };

    const hiddenHandler = () => {
        emit('hidden');
    };

    const hide = () => {
        modal.hide();
    };

    const show = () => {
        modal.show();
    };

    defineProps({
        button: { required: false, type: String },
        additionalClass: { required: false, type: [Array, Object, String] },
        bodyClass: { required: false, type: [Array, Object, String] },
        id: String,
        close: { required: false, type: Boolean },
        large: { default: false, type: Boolean },
        noButton: { default: false, type: Boolean }
    });

    defineExpose({ show, hide });

    onMounted(() => {
        const el = root.value;
        modal = new bootstrap.Modal(el, { keyboard: false });

        el.addEventListener('shown.bs.modal', shownHandler);
        el.addEventListener('hidden.bs.modal', hiddenHandler);
    });
</script>
